The HTTP status code returned by the subscription endpoint.

When an HTTP response wasn't received a synthetic status code will be generated:

- For `InvalidUrl` the status code will be set to `400`.
- For `RequestTimeout` the status code will be set to `504`.
